import { RefObject } from 'react';
import { MutableRefObject } from 'react';
import { ChangeEvent } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useCallback } from 'react';

interface UseUncontrolledParams<T> {
  value: string;
  defaultValue?: string;
  onChange: (value: any) => void;
  inputRef?: RefObject<HTMLInputElement>;
}

interface UseUncontrolledResult<T> {
  defaultValue: string;
  value: undefined;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  inputRef: RefObject<HTMLInputElement>;
}

export const useUncontrolled = <Value>({
  value,
  defaultValue,
  onChange: originalOnChange,
  inputRef: originalInputRef,
}: UseUncontrolledParams<Value>): UseUncontrolledResult<Value> => {
  const internalInputRef = useRef<HTMLInputElement>(null);
  const inputRef = originalInputRef || internalInputRef;

  const handleInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      originalOnChange(e.target.value);
    },
    [originalOnChange],
  );

  useEffect(() => {
    if (inputRef.current && inputRef.current.value !== value) {
      inputRef.current.value = value;
    }
  }, [inputRef, value]);

  return {
    defaultValue: defaultValue || value,
    value: undefined,
    onChange: handleInputChange,
    inputRef,
  };
};
